<template>
  <div class="table-form">
    <el-form
      :model="form"
      ref="ruleForm"
      label-width="140px"
      class="ruleForm"
      v-if="refush"
    >
      <el-form-item
        :prop="item.field"
        :label="item.label"
        v-for="(item, index) in dataSource"
        :key="index"
        :class="item.class"
        :style="{ width: item.width ? item.width : '' + '!important' }"
        :rules="item.rules"
      >
        <!-- 下拉菜单 -->
        <type-select
          v-if="item.formtype == 'select'"
          :data="item"
          @inputChange="inputChange"
          :modelDat="form[item.field]"
          :disableStatus="disable"
          :multiple="multiple"
        ></type-select>
        <!--日期 -->
        <type-date
          v-else-if="item.formtype == 'date'"
          :data="item"
          :disableStatus="disable"
          @inputChange="inputChange"
          :modelDat="form[item.field]"
        ></type-date>
        <!--上传 -->
        <type-upload
          v-else-if="item.formtype == 'upload'"
          :data="item"
          @inputChange="inputChange"
          :modelDat="form[item.field]"
        ></type-upload>
        <!-- 输入框 -->

        <type-input
          v-else
          :data="item"
          @inputChange="inputChange"
          :modelDat="form[item.field]"
          :disableStatus="disable"
          :autosize="item.autosize"
          :type="item.formtype"
        ></type-input>
        <!-- {{form[item.field]}} -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import typeInput from "./input";
import typeSelect from "./select";
import typeUpload from "./upload";
import typeDate from "./date";

const inputRule = [
  { required: true, message: "请输入活动名称", trigger: "blur" },
];

export default {
  components: {
    typeInput,
    typeSelect,
    typeUpload,
    typeDate,
  },

  props: {
    dataSource: {
      require: true,
    },
    tableData: {
      /* type: Object,
      default: function() {
        return {
          // a:1,
          // b:'是'
        };
      }, */
    },
    // 是否可编辑
    disable: {
      default: false,
    },
  },

  data() {
    return {
      form: {},
      rules: {},
      refush: true,
      rowsNumber: 5,
      width: "",
      className: "",
      multiple: false,
    };
  },
  beforeMount() {
    this.initalize()
  },
  mounted() {
    console.log("mounted被调用了");
    console.log("mounted -- this.tableData", JSON.stringify(this.tableData));
    console.log("mounted -- this.dataSource", JSON.stringify(this.dataSource));
  },
  updated() {
    this.dataSource.map((item) => {
      if (item.class === "block") {
        this.width = "100%";
      } else if (item.label === "拟投行业") {
        this.multiple = true;
      } else {
        this.width = "50%";
        // this.selectChange = false;
      }
    });
  },

  methods: {
    /*   initData() {
      // console.log("强制刷新");
      this.$forceUpdate();
      this.$nextTick(() => {
        this.dataSource.forEach((item) => {
          this.$set(this.form, item.field, this.tableData[item.field] || "");
          this.$set(this.rules, item.field, inputRule);
        });
      });

      console.log(
        "tableForm组件--initData方法,传入的tableData数据--JSON",
        JSON.stringify(this.tableData)
      );
      console.log(
        "tableForm组件--initData方法,this.form--JSON",
        JSON.stringify(this.form)
      );
      console.log(
        "tableForm组件--this.form.qualification",
        this.form["qualification"]
      );
    }, */
    inputChange(val) {
      this.form[val.key] = val.value;
      //选择否时，办公面积不可填
      // if (val.value === false) {
      //   this.dataSource[5].disabled = true;
      // } else {
      //   this.dataSource[5].disabled = false;
      // }

      if (val.key == "associationRegiste") {
        this.setRegiste(val.value);
      }
      this.$emit("inputChange", val);
    },

    setRegiste(val) {
      console.log("setRegiste执行了");
      // if (val == 1) {
      //   // this.dataSource.associationRegisteFinished.disable = true;
      // } else {
      //   // this.dataSource.associationRegisteFinished.disable = false;
      // }
    },

    submitForm() {
      const _is = this.validate();
      console.log("_is", _is);
      if (_is == false) {
        console.log("表单验证失败");
        this.$message({
          message: "请将信息填写正确！",
          type: "warning",
        });
        return false;
      }
      return true;
    },

    validate() {
      let _is;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log("验证通过");
          _is = true;
        } else {
          console.log("验证失败");
          _is = false;
        }
      });
      return _is; 
    },
    initalize() {
      this.form = {};
      this.dataSource.forEach((element) => {
        this.$set(this.form, element.field, "");
      });
    },
  },

  watch: {
    /* dataSource为表字段名  tableData为表数据 */
    dataSource: {
      handler(newValue) {
        this.initalize();
        console.log("tableForm组件 -- watch@dataSource", newValue);
      },
      deep: true,
    },
    tableData: {
      handler(newValue) {
        console.log(
          "tableForm组件 -- watch@tableData",
          JSON.stringify(newValue)
        );
        this.initalize();
        for (const key in newValue) {
          const element = newValue[key];
          if (typeof element == "number") {
            this.form[key] = element.toString();
          } else {
            this.form[key] = element;
          }
        }
        // this.form = newValue;
        if (this.form.associationRegiste) {
          console.log("触发了更改");
          this.setRegiste(this.form.associationRegiste);
        }
      },
      // immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.infoLine {
  width: 100% !important;
  border-bottom: 1px solid #e1e1e1;
}
.telLine .el-form-item__label {
  border-top: none !important;
}
.input-form ::v-deep  a[data-v-005d384e] {
  color: #3165ff !important;
}
.table-form {
  .block {
    width: 100% !important;
  }
  ::v-deep  .el-textarea.is-disabled .el-textarea__inner {
    min-height: 50px !important;
    height: 100px !important;
  }
  ::v-deep  .infoLine .el-form-item__label {
    // height: 130px !important;
  }
}
</style>
